import { createFileRoute, redirect } from '@tanstack/react-router';
import { isStandalone } from '~portal/lib';
import { ReportsPage } from './-reports/ReportsPage';

/**
 * @desc The reports page (portal UX baseline): an honest placeholder describing the planned
 * builder flow. Platform-only: the standalone build is the chat app alone, so it redirects.
 */
export const Route = createFileRoute('/_protected/reports')({
  beforeLoad: () => {
    if (isStandalone) {
      throw redirect({ to: '/chat/$conversationId', params: { conversationId: 'new' } });
    }
  },
  component: ReportsPage,
});
